import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Icons } from './Icons'
import LockIcon from '../assets/icons/candado.svg'

export const CardThumbPreview = (props) => {
  const {
    contentId,
    contentIdMedia,
    contentTitle,
    cardType,
    image,
    isUnlocked,
    preferredPlan,
  } = props

  const [previewLoaded, setPreviewLoaded] = useState(false);

  const [previewTick, setPreviewTick] = useState(() => Date.now())

  useEffect(() => {
    const id = setInterval(() => setPreviewTick(Date.now()), 25000)
    return () => clearInterval(id)
  }, [])

  return (
    <Link to={!isUnlocked ? { pathname: '/planes', search: preferredPlan ? `?preferredPlan=${preferredPlan}` : '' } : `/player/live/${contentId}`}>
      <article className='articleItemBox thumbPlayerItem' id={`mdstrmThumb${contentId}`} data-title={contentTitle}>
        <figure className='ratioImgBox ratioThumb'>
          {!isUnlocked && <Icons path={LockIcon} className='lockIcon' />}
          {cardType === "Live" && <span className='liveTag' style={{ opacity: previewLoaded ? '0' : '1' }}>Vivo</span>}
          <img src={image} alt={contentTitle} />
          <div className='thumbPlayerData' style={{ opacity: previewLoaded ? '1' : '0' }}>
            <p>{contentTitle}</p>
          </div>
          <img
            src={`https://thumbs.cdn.mdstrm.com/thumbs/live-stream/${contentIdMedia}/preview.webp?=${previewTick}`}
            alt={contentTitle}
            onLoad={() => setPreviewLoaded(true)}
            onError={() => setPreviewLoaded(false)}
            style={{ opacity: previewLoaded ? '1' : '0' }}
          />
          <div className='thumbPlayerCover'>
            <p>{contentTitle}</p>
          </div>
        </figure>
      </article>
    </Link>
  )
}